import { render, staticRenderFns } from "./SigmafolioModel.html?vue&type=template&id=7f640388&scoped=true&"
import script from "./SigmafolioModel.js?vue&type=script&lang=js&"
export * from "./SigmafolioModel.js?vue&type=script&lang=js&"
import style0 from "./SigmafolioModel.scss?vue&type=style&index=0&id=7f640388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f640388",
  null
  
)

export default component.exports